import { Routes } from '@angular/router';
import { CallInvitationComponent } from './call-invitation/call-invitation.component';
import { TokboxComponent } from './tokbox/tokbox-viewer/tokbox.viewer.component';


export const videoroutes: Routes = [
    { path: 'show/:sessionId/:name', component: TokboxComponent },
    // { path: 'show/:sessionId/:name/:s_id/:waitingroomId', component: TokboxComponent },
    { path: 'show/:sessionId/:name/:s_id/:waitingroomId/:clinicianId', component: TokboxComponent },
    { path: 'show/:sessionId/:uniqueId/:clinicianId/:invitation/:name', component: TokboxComponent },
    { path: 'show/:sessionId/:uniqueId/:clinicianId/:invitation/:name/:token/:s_id', component: TokboxComponent },
    { path: 'show/:sessionId/:name/:clinicianId', component: TokboxComponent },
    { path: 'show/:sessionId/:name/:s_id/:clinicianId', component: TokboxComponent },
    { path: 'invite/:token', component: CallInvitationComponent },
];
